import { ComponentProps } from 'react';
import Image from 'antd/es/image';
import clsx from 'clsx';

interface OpImageProps extends ComponentProps<typeof Image> {}

/**
 * OpImage is a wrapper around Ant Design's Image component.
 * It displays images with optional preview functionality and error handling.
 * 
 * Use this component for displaying images throughout the application with consistent behavior.
 * Supports lazy loading, fallback images, and image preview. Defaults to preview disabled.
 * 
 * @example
 * <OpImage src="/path/to/image.jpg" alt="Description" />
 * <OpImage src="/path/to/image.jpg" preview={true} />
 * 
 */
export const OpImage = ({
  className,
  preview = false,
  ...imageProps
}: OpImageProps) => {
  return (
    <Image
      className={clsx('op-image', className)}
      preview={preview}
      {...imageProps}
    />
  );
};
